<template>
  <div class="d-flex align-items-center">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 27" v-bind:svg-inline="''" v-bind:style="'width: 24px'" v-bind:class="'me-2'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#a)"><path fill="#429488" fill-rule="evenodd" stroke="#429488" d="M13.528.551a2.616 2.616 0 00-.36.038c-.122.037-.252.049-.295.026-.047-.026-.551.005-.871.053-.111.017-.422.06-.69.096-.735.098-.772.104-1.276.204a22.623 22.623 0 00-5.652 1.939c-.784.39-1.037.56-1.415.958a3.571 3.571 0 00-.965 2.64 23.165 23.165 0 002.714 9.937c.062.09.561.964.616 1.076.057.117.307.512.585.925a22.92 22.92 0 005.968 6.056c.98.68 1.384.876 2.038.993.258.047.833.054 1.083.013.624-.1 1.035-.281 1.801-.794a22.868 22.868 0 005.629-5.345c.43-.577 1.14-1.632 1.216-1.81.03-.07.433-.772.57-.996.132-.213.639-1.236.833-1.681a23.3 23.3 0 001.927-7.943c.032-.526.015-1.064-.044-1.342a3.57 3.57 0 00-1.416-2.186c-.202-.147-.992-.56-1.58-.829a22.602 22.602 0 00-4.463-1.503A14.65 14.65 0 0018.188.83a33.574 33.574 0 01-1.193-.165 4.877 4.877 0 00-.648-.04c-.262-.003-.471-.015-.507-.03-.147-.057-1.567-.083-2.312-.043zm-.081.57l-.446.03c-2.202.142-4.48.666-6.68 1.536l-.208.082.602.112c2.08.384 4.012.601 6.137.689.67.028 2.643.028 3.314 0a43.023 43.023 0 005.206-.526 40.874 40.874 0 001.504-.276 8.101 8.101 0 00-.457-.182 21.98 21.98 0 00-6.752-1.457 46.297 46.297 0 00-2.22-.008zm-8.595 2.22c-.923.433-1.188.598-1.515.946a2.718 2.718 0 00-.752 1.928c0 .301.075 1.341.103 1.435.008.023.12.158.252.3.622.67 1.506 1.746 2.277 2.774a43.915 43.915 0 015.289 9.202c.534 1.263 1.098 2.804 1.373 3.754.024.085.05.112.23.243.41.3 1.027.703 1.196.784.41.197.737.27 1.204.269.362 0 .554-.03.876-.139.345-.116.692-.323 1.454-.87.251-.18.28-.208.294-.278.048-.261.561-1.734.934-2.685a43.721 43.721 0 015.411-9.856c.834-1.143 1.983-2.56 2.602-3.207l.243-.254.043-.457c.064-.677.076-1.2.034-1.459-.125-.76-.565-1.462-1.173-1.872-.193-.13-.686-.383-1.224-.63l-.281-.129-.256.064c-.94.235-2.747.533-4.23.696-1.631.18-3.01.255-4.738.255a40.36 40.36 0 01-5.099-.298c-1.308-.154-3.076-.454-3.856-.653a5.965 5.965 0 00-.256-.062c-.005 0-.201.09-.435.2zm9.085 3.948c-2.101.287-3.679 2.105-3.677 4.237 0 .666.138 1.271.425 1.872.36.754.944 1.395 1.653 1.817a4.335 4.335 0 001.778.582c.227.021.337 0 .364-.073.011-.029.023-.024.076.026.058.056.073.06.215.054.213-.008.524-.057.783-.123a4.292 4.292 0 002.006-7.117 4.219 4.219 0 00-2.515-1.278 5.13 5.13 0 00-1.108.003zm.136.417c-1.704.209-3.029 1.48-3.337 3.2-.057.316-.053.963.008 1.297a3.841 3.841 0 003.215 3.138l.213.032.073-.064a.386.386 0 01.51-.01l.095.073.212-.032a3.601 3.601 0 001.165-.378c.39-.198.64-.382.97-.715.33-.333.513-.584.712-.982a3.8 3.8 0 00.401-1.994 3.836 3.836 0 00-3.122-3.525 4.915 4.915 0 00-1.115-.04zM2.79 8.657c.007.035.05.3.098.589.195 1.187.45 2.237.81 3.341a22.085 22.085 0 006.21 9.585c.42.38 1.22 1.048 1.236 1.031.025-.024-.55-1.592-.891-2.434a43.935 43.935 0 00-2.458-5.085 43.253 43.253 0 00-4.683-6.706c-.363-.426-.335-.398-.322-.32zm23.01.441a43.372 43.372 0 00-5.054 7.43 59.37 59.37 0 00-1.313 2.66c-.422.939-.79 1.836-1.121 2.727a31.603 31.603 0 00-.46 1.308c.009.009.724-.59 1.098-.92a26.02 26.02 0 001.706-1.684A22.191 22.191 0 0026.004 9.93c.089-.455.216-1.239.208-1.28-.003-.02-.168.158-.412.447z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h30v26.808H0z"/></clipPath></defs></svg>

    <p v-if="!sensorData && $apollo.queries.sensorData.loading">
      Loading sensor data...
    </p>

    <p v-else-if="sensorData && environment">
      Temperature: {{ formatTemperature(environment.temperature) }} |
      Humidity: {{ environment.humidity.toFixed(1) }}% |
      Pressure: {{ formatPressure(environment.barometricPressure) }}<br />
      AQI: {{ Math.round(environment.aqi) }} |
      Light: {{ light.clear }} ({{ light.nir }} nIR)

      <em>(Last updated {{ timeSinceUpdate.humanize() }} ago)</em>
    </p>

    <p v-else class="text-dark text-opacity-50 fst-italic">No sensor data available.</p>
  </div>
</template>

<script>
import moment from 'moment'

import FormatTemperatureMixin from 'mixins/FormatTemperature'
import FormatPressureMixin from 'mixins/FormatPressure'

import StationSensorsQuery from 'queries/StationSensors.graphql'

export default {
  mixins: [FormatTemperatureMixin, FormatPressureMixin],

  props: {
    station: {
      type: Object,
      required: true
    },

    autoload: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      skipSensors: !this.autoload,
      sensorData: null
    }
  },

  apollo: {
    sensorData: {
      query: StationSensorsQuery,

      variables() {
        return {
          stationId: this.station.id
        }
      },

      skip() {
        return this.skipSensors
      }
    }
  },

  computed: {
    environment () { return this.sensorData.sensors.environment },
    light () { return this.sensorData.sensors.light },

    timeSinceUpdate() {
      const updatedAt = moment.parseZone(this.environment.timestamp)
      const now = moment(new Date())
      return moment.duration(now.diff(updatedAt))
    }
  },

  methods: {
    loadData () {
      this.skipSensors = false
      this.$apollo.queries.sensorData.refetch()
    }
  }
}
</script>
